const publications = new Swiper('.swiperPublications', {
	slidesPerView: 1.2,
	autoHeight: true,
	spaceBetween: 30,
	navigation: {
		nextEl: '.publications-button-next',
		prevEl: '.publications-button-prev',
	},
	breakpoints: {
		768: {
		  slidesPerView: 1.8,
		},
	},
});

const documents = new Swiper('.swiperDocuments', {
	slidesPerView: 1.2,
	autoHeight: true,
	spaceBetween: 30,
	navigation: {
		nextEl: '.documents-button-next',
		prevEl: '.documents-button-prev',
	},
	breakpoints: {
		768: {
		  slidesPerView: 1.8,
		},
	},
});

const articlesRecherche = new Swiper('.swiperRecherche', {
	slidesPerView: 1,
	autoHeight: true,
	spaceBetween: 30,
	navigation: {
		nextEl: '.actus-recherche-button-next',
		prevEl: '.actus-recherche-button-prev',
	},
	breakpoints: {
		768: {
		  slidesPerView: 2,
		},
	},
});

const articlesEnseignement = new Swiper('.swiperEnseignement', {
	slidesPerView: 1,
	autoHeight: true,
	spaceBetween: 30,
	navigation: {
		nextEl: '.actus-enseignement-button-next',
		prevEl: '.actus-enseignement-button-prev',
	},
	breakpoints: {
		768: {
		  slidesPerView: 2,
		},
	},
});

const articlesValorisation = new Swiper('.swiperValorisation', {
	slidesPerView: 1,
	autoHeight: true,
	spaceBetween: 30,
	navigation: {
		nextEl: '.actus-valorisation-button-next',
		prevEl: '.actus-valorisation-button-prev',
	},
	breakpoints: {
		768: {
		  slidesPerView: 2,
		},
	},
});
